import type React from 'react'
import { Navigate } from 'react-router-dom'
import { useProfile } from '@/hooks/use-profile'

export function DefaultRedirect(): React.ReactElement {
  const { defaultOrgSlug, loading } = useProfile()

  if (loading) {
    return <div className="flex min-h-screen items-center justify-center text-neutral-500">Loading...</div>
  }

  if (defaultOrgSlug) {
    return <Navigate to={`/${defaultOrgSlug}/plans`} replace />
  }

  // Shouldn't reach here due to RequireOnboarding, but fallback
  return <Navigate to="/onboarding/org" replace />
}
